<template>
  <component :is="layout" class="min-h-screen">
    <router-view :key="$route.path" />
  </component>
</template>

<script>
import { useAuthStore } from '@/stores/auth.js'

export default {
  name: 'App',
  computed: {
    layout() {
      return this.$route.meta.layout || 'div'
    }
  },
  async mounted() {
    if(!useAuthStore().user) {
      useAuthStore().attempt_user()
    }
  }
}
</script>
